import React, { useState, useEffect } from 'react'
import { ProgressByUser } from '../../controllers/ProgressByUser';
import { GetCourses } from '../../controllers/GetCourses';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../actions/auth';
import { NavBarHome } from '../../components/ui/NavBarHome';
import { ProgressScreenC } from './ProgressScreenC';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';

export const ProgressScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const [list, setList] = useState([]);
    const [courses, setCourses] = useState([]);
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }

    let ran = false;
    useEffect(() => {
        if (ran) return;
        GetCourses(token, user.languaje)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourses(e);
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
                // history( '/auth/login', {
                //     replace: true
                // });
            });
        ProgressByUser(token, user.id)
        .then((e)=>{
            setList(e)
            }
        ).catch((e)=>{
            console.error(e);
            // dispatch(logout(token));
        });

        return () => (ran = true);
    }, [])

    const disCourse = ()=>{
        if(list.status === "Token is Expired" ){
            dispatch(logout(token));
            history( '/auth/login', {
                replace: true
                });  
        }
        if(list && courses.length>0){
            const entries = Object.values(list);
            let enCourses = Object.values(courses);
            
            return entries.map((course) => 
                    <ProgressScreenC
                    key={course.course_id}
                    id={course.course_id}
                    user_contents={course.user_contents}
                    total_contents={course.total_contents}
                    coursesL = {enCourses.find(courseN => courseN.id === course.course_id)}
                    />       
            );
        }
    }

    return (
        <div className="content">
            <NavBarHome />
            <div className="text-title">{transTxt.menu.progreso}</div>
                <div className="fund-main-question">
                    <div className="content-questions" >
    
                        <div className="container-question">
                        {!list && <div className="loader-page"><TailSpin
                            color="#00BFFF"
                            height={200}
                            width={200}
                        />
                        </div>}
                        { list && disCourse() }
                    </div>            
                </div>
            </div>
        </div>
    )
}


